<mat-toolbar color="primary">Parchment Integration</mat-toolbar>

<mat-dialog-content>
  @if (integration$ | async; as integration) {
    <div class="flex flex-col items-start gap-4">
      <div class="flex gap-4">
        <strong>Organisation Id:</strong>
        <span>{{ integration.data.organisationId }}</span>
      </div>

      <div class="flex gap-4">
        <strong>User Id:</strong>
        <span>{{ integration.data.userId }}</span>
      </div>

      <button mat-stroked-button class="!px-2" (click)="removeIntegration()">
        <div class="flex items-center gap-2">
          <img class="h-6 w-6" src="/assets/integrations/parchment.png" />
          <span>Remove Parchment Integration</span>
        </div>
      </button>
    </div>
  } @else {
    <button mat-stroked-button class="!px-2" (click)="addIntegration()">
      <div class="flex items-center gap-2">
        <img class="h-6 w-6" src="/assets/integrations/parchment.png" />
        <span>Connect with Parchment</span>
      </div>
    </button>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button type="button" mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
